import Vue from "vue";
import VueRouter from "vue-router";

import ColorfulBytes from "@/views/colorful-bytes/ColorfulBytes";
import ColorfulBytesHome from "@/views/colorful-bytes/Home";
import ColorfulBytesContact from "@/views/colorful-bytes/Contact";
import StageGuide from "@/views/stage-guide/StageGuide";
import StageGuideHome from "@/views/stage-guide/Home";
import StageGuidePricing from "@/views/stage-guide/Pricing";
import Coaching from "@/views/coaching/Coaching";
import DataPrivacy from "@/views/general/DataPrivacy";
import Team from "@/views/general/Team";

Vue.use(VueRouter);

const colorfulBytes = {
  path: "/",
  component: ColorfulBytes,
  meta: {
    title: "Colorful Bytes | Digital dabei"
  },
  children: [
    {
      path: "",
      name: "colorful-bytes-home",
      component: ColorfulBytesHome,
      meta: {
        title: "Colorful Bytes | Digital dabei"
      }
    },
    {
      path: "team",
      name: "colorful-bytes-team",
      alias: "/stage-guide/team",
      component: Team,
      meta: {
        title: "Colorful Bytes | Digital dabei | Team"
      }
    },
    {
      path: "coaching",
      name: "coaching-home",
      component: Coaching,
      meta: {
        title: "Colorful Bytes | Coaching &amp; Consulting"
      }
    },
    {
      path: "contact",
      name: "colorful-bytes-contact",
      component: ColorfulBytesContact,
      meta: {
        title: "Colorful Bytes | Digital dabei | Kontakt"
      }
    },
    {
      path: "data-privacy",
      name: "colorful-bytes-data-privacy",
      component: DataPrivacy,
      meta: {
        title: "Colorful Bytes | Digital dabei | Datenschutzerklärung"
      }
    }
  ]
};

const stageGuide = {
  path: "/stage-guide",
  component: StageGuide,
  meta: {
    title: "Stage-Guide | Infodisplays und Social-Walls für Ihr Event"
  },
  children: [
    {
      path: "",
      name: "stage-guide-home",
      component: StageGuideHome,
      meta: {
        title: "Stage-Guide | Infodisplays und Social-Walls für Ihr Event"
      }
    },
    {
      path: "team",
      name: "stage-guide-team",
      component: Team,
      meta: {
        title: "Stage-Guide | Team"
      }
    },
    {
      path: "data-privacy",
      name: "stage-guide-data-privacy",
      component: DataPrivacy,
      meta: {
        title: "Stage-Guide | Datenschutzerklärung"
      }
    },
    {
      path: "pricing",
      name: "stage-guide-pricing",
      component: StageGuidePricing,
      meta: {
        title: "Stage-Guide | Digital dabei | Preise"
      }
    }
  ]
};

const routes = [];

switch (process.env.VUE_APP_TYPE) {
  case "STAGEGUIDE":
    stageGuide.path = "/";
    routes.push(stageGuide, { path: "*", redirect: "/" });
    break;
  default:
    routes.push(colorfulBytes, stageGuide, { path: "*", redirect: "/" });
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      let top = 0;
      if (to.hash === "#footer") {
        top = document.querySelector(to.hash) ? document.querySelector(to.hash).offsetTop + 500 : top;
      } else {
        top = document.querySelector(to.hash) ? document.querySelector(to.hash).offsetTop - 100 : top;
      }
      return window.scrollTo({
        top,
        behavior: "smooth"
      });
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Stage-Guide | Infodisplays und Social-Walls für Ihr Event";
  next();
});

export default router;
